import { createTheme, responsiveFontSizes } from "@mui/material";
import { green } from "@mui/material/colors";
const theme = createTheme({
  palette: {
    primary: {
      main: green[600],
      light: '#ecf7eb'
    },
  },
  typography: {
    fontFamily: '"Noto Sans", sans-serif',
  },
});

export default responsiveFontSizes(theme);
